import Types from '../types';

export default error => ({
  type: Types.ADD_ERROR,
  payload: error,
});
